import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { Divider, Table, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import 'moment/locale/es'

import Pagination from '../../../components/Pagination'
import CallButton from '../../../components/CallButton'
import WhatsappButton from '../../../components/WhatsappButton'
import CustomerInvoicesDrawer from './CustomerInvoicesDrawer'
import NewSaleLogModal from '../../SaleLogs/partials/NewSaleLogModal'

export default function CustomersTable({ customers, reload, pagination, setPagination }) {
	const [invoicesDrawer, setInvoicesDrawer] = useState(null)
	const [newSaleLog, setNewSaleLog] = useState(null)
	
	const columns = [
		{
			title: 'Miembro Desde',
			dataIndex: 'member_at',
			render: t => moment(t).format('DD-MM-YYYY')
		},
		{
			title: 'Nombre',
			dataIndex: 'name',
			render: (t, r) => t ? t.toUpperCase() + ' ' + r.id : <em>Sin registro</em>
		},
		{
			title: 'Cédula',
			dataIndex: 'document',
		},
		{
			title: 'Facturas Registradas',
			dataIndex: 'invoices_count',
			render: t => t ? `${t} facturas` : <em>Sin registro</em>
		},
		{
			title: 'Llamadas Registradas',
			dataIndex: 'calls_logs_count',
			render: t => t ? `${t} llamadas` : <em>Sin registro</em>
		},
		{
			title: 'Whatsapp Registradas',
			dataIndex: 'whatsapp_click_logs_count',
			render: t => t ? `${t} whatsapp` : <em>Sin registro</em>
		},
		{
			title: 'Acciones',
			width: '200px',
			render: (t,r) => (
				<React.Fragment>
					<CallButton
						customer={r}
						customerId={r.id}
						reload={reload}
						disabled={!r.active_channels.some(channel => channel.value === 'call')}
					/>
					<WhatsappButton
						customer={r}
						reload={reload}
						disabled={!r.active_channels.some(channel => channel.value === 'call')}
					/>
					<Tooltip title="Registrar Venta">
						<Button size='sm' color="primary" outline className='px-2' onClick={() => setNewSaleLog(r)}>
							<FontAwesomeIcon icon={faDollarSign} />
						</Button>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Ver Facturas">
						<Button size='sm' color="primary" outline className='px-2' onClick={() => setInvoicesDrawer(r.id)}>
							<FontAwesomeIcon icon={faFileInvoiceDollar} />
						</Button>
					</Tooltip>
				</React.Fragment>
			)
		}
	]
	
	return (
		<React.Fragment>
			<Table 
				dataSource={customers}
				columns={columns}
				rowKey={r => r.id}
				loading={!customers}
				pagination={false}
				size="small"
			/>
			<Pagination 
				reload={reload}
				pagination={pagination}
				updatePagination={setPagination}		
			/>
			{ newSaleLog && (
				<NewSaleLogModal 
					visible
					onClose={() => setNewSaleLog(null)}
					customer={newSaleLog}
					reload={reload}
				/>
			)}
			{ invoicesDrawer && (
				<CustomerInvoicesDrawer 
					visible
					onClose={() => setInvoicesDrawer(null)}
					customerId={invoicesDrawer}
				/>
			)}
		</React.Fragment>
	)
}